import { CountryCode } from 'app/pages/admin/users/contactHelper';
import { ErrorMessage, Field, FieldProps, useFormikContext } from 'formik';
import { searchPhoneNumberByLocation } from 'lib/api';
import { TextInput } from 'lib/components';
import CountryDropdown from 'lib/components/country-code-picker/CountryDropdown';
import { errorToast } from 'lib/components/toasts/error';
import { SuperAdminCustomerDetails } from 'lib/context';
import { debounce } from 'lodash';
import React from 'react';
import {
  ErrorMsg,
  FieldContainer,
  FieldLabel,
  getInputField,
  Row,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';
import { DEFAULT_10DLC_COUNTRY } from 'lib/const/SuperAdminConstants';

export const SmsPhoneNumberSection = () => {
  const { isSubmitting, setFieldValue, values } =
    useFormikContext<SuperAdminCustomerDetails>();

  const getPhoneByLocation = React.useCallback(
    debounce(async (location: string) => {
      try {
        if (!location || !location.trim()) {
          setFieldValue('number', '');
          return;
        }

        const params = location.split(',');
        let city = 'Indianapolis';
        let state = 'IN';
        if (params[0] && params[0].trim()) {
          city = params[0].trim();
        }

        if (params[1] && params[1].trim()) {
          state = params[1].trim();
        }

        const resp = await searchPhoneNumberByLocation(
          city,
          state,
          values.country || DEFAULT_10DLC_COUNTRY
        );
        if (resp && resp.data && resp.data.length > 0) {
          setFieldValue('number', resp.data[0].phone_number);
          if (values.country === DEFAULT_10DLC_COUNTRY) {
            setFieldValue('customer10Dlc', {
              ...values.customer10Dlc,
              legalCity: city,
              legalState: state,
            });
          }
        } else {
          errorToast({ title: 'Could not find Phone number.' });
        }
      } catch (error) {
        console.log(error);
        errorToast({ title: 'Could not find Phone number.' });
      }
    }, 2500),
    [values.country]
  );

  const handleCountryChange = (country: CountryCode) => {
    setFieldValue('country', country);
    setFieldValue('location', '');
    setFieldValue('number', '');
    if (country === DEFAULT_10DLC_COUNTRY) {
      setFieldValue('customer10Dlc', {
        ...values.customer10Dlc,
        legalCompanyName: values.business || '',
        w9ContactEmail: values.email || '',
        w9ContactPhone: values.phone1 || '',
        websiteUrl: values.url || '',
      });
    }
  };

  return (
    <Section style={{ paddingTop: '0.5rem' }}>
      <SectionTitle>SMS Phone number</SectionTitle>
      <RowWrapper>
        <Row>
          <FieldLabel>Country</FieldLabel>
          <Field name='country'>
            {() => (
              <FieldContainer>
                <CountryDropdown
                  value={values.country as CountryCode}
                  onChange={handleCountryChange}
                  disabled={isSubmitting}
                  allowedCountries={['US', 'CA']}
                />
                <ErrorMessage name='country' component={ErrorMsg} />
              </FieldContainer>
            )}
          </Field>
        </Row>
        <Row>
          <FieldLabel>Location</FieldLabel>
          <Field name='location'>
            {({ field }: FieldProps) => {
              return (
                <FieldContainer>
                  <TextInput
                    {...field}
                    name='location'
                    type='text'
                    onChange={event => {
                      getPhoneByLocation(event.target.value);
                      setFieldValue('location', event.target.value);
                    }}
                  />
                  <ErrorMessage name='location' component={ErrorMsg} />
                </FieldContainer>
              );
            }}
          </Field>
        </Row>
        <Row>
          <FieldLabel>Number</FieldLabel>
          {getInputField('number', true, true, isSubmitting, 'text', true)}
        </Row>
      </RowWrapper>
    </Section>
  );
};
